import { AuthContextProvider } from "./auth-context";
import { SelectedContextProvider } from "./select-context";

export default function ContextProviders(props) {
  return (
    <AuthContextProvider>
      <SelectedContextProvider>{props.children}</SelectedContextProvider>
    </AuthContextProvider>
  );
}
